export default __webpack_public_path__ + "static/media/medium_blue.1a505142.svg";